// eslint-disable-next-line
import * as R from 'ramda'
import isDate from 'date-fns/isDate'
import differenceInMins from 'date-fns/differenceInMinutes'
import differenceInHours from 'date-fns/differenceInHours'
import differenceInDays from 'date-fns/differenceInDays'
import differenceInMonths from 'date-fns/differenceInMonths'
import getYear from 'date-fns/getYear'

import isFuture from 'date-fns/isFuture'
import isValid from 'date-fns/isValid'
import formatISO from 'date-fns/formatISO'
import cn from 'comma-number'

export const weekdaysArray = [
  'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
]

export const propertyPropMap = property => ({
  title: property.title,
  photoBaseUrl: property.photo_base_url,
  mlsNumber: property.mls_number,
  url: property.url,
  askingPrice: property.asking_price,
  bedrooms: property.bedrooms,
  bathrooms: property.bathrooms,
  parkingSpots: property.parking_spots,
  sqftMin: property.sqft_min,
  sqftMax: property.sqft_max,
  photoVersion: property.photoVersion,
})

const SQFT_SOURCE_ESTIMATE = 'Estimated From Range'
export const getDisplaySqft = (sqft, sqftMin, sqftMax, userIsLoggedIn, sqftSource = '') => {
  let output = ''
  const min = sqftMin || 0
  const max = sqftMax || 0
  const estimated = SQFT_SOURCE_ESTIMATE === sqftSource
  if(!estimated && sqft && userIsLoggedIn) {
    output = `${sqft}`
  } else if(min === max) {
    output = min
  } else {
    output = max
      // somehow backend return null instead of 0
      ? `${cn(min)}-${cn(max)}`
      : min
        ? `+${min}`
        : null
  }
  if(output) output = cn(output)
  return output
}

export const sqrtRangeStringify = (min, max) => {
  let sqrtVal = min || ''
  sqrtVal += (min && max) ? `-${max}` : (min && !max) ? '+' : ''
  return sqrtVal
}


// use this until address page gets cached enpoint
export const getBottomUpArea = (areas) => {
  if(!areas) return null
  return R.keys(
    R.pick([
      'neighbourhood', 'sublocality', 'locality',
      'locality_parent', 'locality_grandparent', 'country',
    ], areas))
    .map(key => {
      if(areas[key]) {
        return {
          areaType: key,
          name: areas[key].display_name,
          ...areas[key],
        }
      }
      return null
    })
    .filter(item => !!item)
}


export const getPageAgentOrMyAgent = (listing, myAgent) => {
  let agent = listing && listing.agent
  if(!agent && !myAgent) return null
  if(!agent && myAgent) return myAgent
  if(myAgent && agent.overwrite !== false) {
    agent = myAgent
  }
  return agent
}

/* eslint-disable */

export const unixTimeStampToDate = (unixTime) => {
  if(!unixTime) return null
  return formatISO(unixTime * 1000)
}
export const ONE_DAY_IN_MINUTES = 1440
export const ONE_HOUR_IN_MINUTES = 60
// listedAt must be string not date

export const listedDaysFormatter = (listedAt) => {
  if(!listedAt) return null
  const date = listedAt.indexOf(' ') > -1 ? new Date(listedAt.replace(' ', 'T')) : new Date(listedAt)
  if(!listedAt || !isDate(date) || !isValid(date) || isFuture(date)) return null
  const diffMinutes = differenceInMins(new Date(), new Date(listedAt))


  let formatted = ''
  if(diffMinutes === 0) return 'Just listed'
  if(diffMinutes < ONE_HOUR_IN_MINUTES) {
    formatted = diffMinutes + ` minute${diffMinutes > 1 ? 's' : ''}`
  } else if(diffMinutes < ONE_DAY_IN_MINUTES) {
    const diffHours = Math.floor(diffMinutes / ONE_HOUR_IN_MINUTES)
    formatted = diffHours + ` hour${diffHours > 1 ? 's' : ''}`
  } else {
    const diffDays = Math.floor(diffMinutes / ONE_DAY_IN_MINUTES)
    formatted = diffDays + ` day${diffDays > 1 ? 's' : ''}`

    // if(diffDays < 180) {
    //   formatted = diffDays + ` day${diffDays > 1 ? 's' : ''}`
    // } else if(diffDays <= 365) {
    //   const monthAgo = Math.round((diffDays / 30))
    //   formatted = `${monthAgo} month${monthAgo > 1 ? 's' : ''}`
    // } else {
    //   const yearAgo = Math.round(diffDays / 365)
    //   formatted = `${yearAgo} year${yearAgo > 1 ? 's' : ''}`
    // }
  }
  // formatted += ' ago'
  return formatted
}


export const archivedSoldDaysFormatter = (endDateUnix) => {
  if(!endDateUnix) return null

  const endDate = new Date(endDateUnix * 1000)

  const diffHours = differenceInHours(new Date(), new Date(endDate))
  const diffDays = differenceInDays(new Date(), new Date(endDate))
  const diffMonth = differenceInMonths(new Date(), new Date(endDate))

  let formatted = ''
  if(diffDays === 0) {
    formatted = diffHours + ` hour${diffDays > 1 ? 's' : ''} ago`
  } else if(diffMonth < 3) {
    formatted = diffDays + ` day${diffDays > 1 ? 's' : ''} ago`
  } else if(diffMonth < 12) {
    formatted = diffMonth + ` month${diffMonth > 1 ? 's' : ''} ago`
  } else {
    formatted = ' in ' + getYear(endDate)
  }
  return formatted
}


export const toMetric = ft => {
  if(!ft) return null
  return Math.round(ft * 0.3048 * 100) / 100
}


export const appendImageTimestamp = (url, timestamp = '') => {
  if(!url) return ''
  return url + '?v=' + (timestamp || 1)
}

export const checkListingLocked = (
  {
    listing = {},
    isArchived,
    userIsAuthentificated = false,
    /**
     * when user is not logged in and terms condition requires, it also need to be locked
     */
    termsConditionRequiredId = false,
    requiredEmailVerification = false,
    requireTermsConditionAgreement = false,
  }
) => {
  const isLocked = !userIsAuthentificated && Boolean(listing && listing.advertise_permission === 0)
  // when terms required and user is not logged in
  return  Boolean(
    (!userIsAuthentificated && (isArchived || isLocked || termsConditionRequiredId))
    || (userIsAuthentificated && (requiredEmailVerification || requireTermsConditionAgreement))
  )
}

export const checkListingRequiresEmailVerification = (
  {
    userIsAuthentificated,
    userEmailVerified,
    isArchived,
    requireTermsEmailVerification,
  }
) => {

  return Boolean(
    userIsAuthentificated
    && (!userEmailVerified && isArchived)
        || (!userEmailVerified && requireTermsEmailVerification)
  )
}


// eslint-disable-next-line
export const getListingDetails = (listing) => {
  if(!listing) return {}
  if(listing && !R.isEmpty(listing)) {
    return {
      tax: listing.tax,
      sqftMin: listing.sqft_min,
      sqftMax: listing.sqft_max,
      lockers: listing.locker_type,
      lotSize: listing.lot_size,
      lotFront: listing.lot_front,
      lotDepth: listing.lot_depth,
      parkingSpots: listing.parking_spots,
      petsPermitted: listing.pets_permitted,
      heatType: listing.heat_type,
      exposure: listing.exposure,
      frontingOn: listing.fronting_on,
      outdoor_space: listing.outdoor_space,
      ensuiteLaundry: listing.ensuite_laundry,
      propertyType: listing.property_type,
      maintenanceFee: listing.maintenance_fee,
      level: listing.level,
      dateAvailable: listing.date_available,
      buildingAge: listing.building_age,
      mlsNumber: listing.mls_number,
      propertyClass: listing.property_class,
      style: listing.style,
      id: listing.id,
    }
  }
}
// eslint-disable-next-line
export const getListingIncluded = (listing) => {
  if(listing && !R.isEmpty(listing)) {
    return {
      heatInc: listing.heat_inc,
      airconInc: listing.aircon_inc,
      waterInc: listing.water_inc,
      hydroInc: listing.hydro_inc,
      cableInc: listing.cable_inc,
      commonElementsInc: listing.common_elements_inc,
      buildingInsurance: listing.building_insurance,
      parkingIncluded: listing.parking_included,
    }
  }
}
